/**
 * @generated SignedSource<<f37bd510bccb1fda122ad5851346a267>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PolicyCollectionItemInput = {
  policyUUID: string;
  policyVersion?: number | null | undefined;
  uuid: string;
};
export type UpdatePolicyCollectionItemMutation$variables = {
  input: PolicyCollectionItemInput;
};
export type UpdatePolicyCollectionItemMutation$data = {
  readonly updatePolicyCollectionItem: {
    readonly collection: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type UpdatePolicyCollectionItemMutation = {
  response: UpdatePolicyCollectionItemMutation$data;
  variables: UpdatePolicyCollectionItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PolicyCollectionPayload",
    "kind": "LinkedField",
    "name": "updatePolicyCollectionItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PolicyCollection",
        "kind": "LinkedField",
        "name": "collection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePolicyCollectionItemMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdatePolicyCollectionItemMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a097f6ca5b9d9db9d50d0cc0cbe5a962",
    "id": null,
    "metadata": {},
    "name": "UpdatePolicyCollectionItemMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePolicyCollectionItemMutation(\n  $input: PolicyCollectionItemInput!\n) {\n  updatePolicyCollectionItem(input: $input) {\n    collection {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2b55e2e0b5f423b2910f17186d98026";

export default node;
